export const UserInteractionConstant = {
    API: 'UserInteraction'
}

export const UserInteractionAPIConstant = {
    PVPieChart: UserInteractionConstant.API +'/getUserInteractionPVPieChart',
    topUserInteractions: UserInteractionConstant.API +'/topUserInteractions',
    UserInteractionsPVOrReportsTableData:UserInteractionConstant.API +'/getUserInteractionsPVOrReportsTableData'

}